export default "/vehicleCluster1.png"